module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"MOC Deliveries","noDeliveries":"No deliveries yet."}}')
  delete Component.options._Ctor
}
